export const DEFAULT_LANGUAGE = 'en';

export const MAX_TECHNIQUE_NAME_KEY_LENGTH = 31;

export const ALL_FILTER = 'All';

export const SEARCH_DEBOUNCE_MS = 300;

export const SEARCH_PROJECTS_STORAGE_KEY = 'fielddata.myProjects.searchString';

export enum Permissions {
  admin = 'ADMIN',
  superAdmin = 'SUPER_ADMIN'
}

export enum ApiTypes {
  fd = 1,
  iso = 2,
  data2rig = 5
}
